export default __webpack_public_path__ + "static/media/tormozkalotka.8ab03a2e.jpg";